export class HourRepresentation {
  constructor(
    public readonly from: number,
    public readonly to: number,
  ) {}
}
